// extracted by mini-css-extract-plugin
module.exports =  {"header":"Trends-module_header_d363c","title":"Trends-module_title_fb707","container":"Trends-module_container_bff9f"};